<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">You Are My Possible</h1><ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li><li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li><li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li><li id="toc-li-4"><a href="#/text/ch004#chapter-1-insatiable">Chapter 1: Insatiable</a></li><li id="toc-li-5"><span href="#/text/ch005#chapter-2-round-two" title="Link target outside of Sample">Chapter 2: Round Two?</span></li><li id="toc-li-6"><span href="#/text/ch006#chapter-3-curry-or-cum" title="Link target outside of Sample">Chapter 3: Curry or Cum?</span></li><li id="toc-li-7"><span href="#/text/ch007#chapter-4-can-i-keep-you" title="Link target outside of Sample">Chapter 4: Can I Keep You?</span></li><li id="toc-li-8"><span href="#/text/ch008#chapter-5-between-our-fingers" title="Link target outside of Sample">Chapter 5: Between Our Fingers</span></li><li id="toc-li-9"><span href="#/text/ch009#chapter-6-love-me-like-you-do" title="Link target outside of Sample">Chapter 6: Love Me Like You Do</span></li><li id="toc-li-10"><span href="#/text/ch010#chapter-7-two-wrongs-dont-make-a-right-or-do-they" title="Link target outside of Sample">Chapter 7: Two Wrongs Don’t Make a Right, or Do They?</span></li><li id="toc-li-11"><span href="#/text/ch011#chapter-8-friends-with-benefits" title="Link target outside of Sample">Chapter 8: Friends with Benefits?</span></li><li id="toc-li-12"><span href="#/text/ch012#chapter-9-catch-me-when-i-fall" title="Link target outside of Sample">Chapter 9: Catch Me When I Fall</span></li></ol></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?3c911c55